import {
  CLEAR_ORDER,
  GET_ORDER_REQUEST,
  GET_ORDER_SUCCESS,
  GET_ORDER_ERROR,
  GET_ORDER_REQ_REQUEST,
  GET_ORDER_REQ_SUCCESS,
  GET_ORDER_REQ_ERROR,
  SAVE_ORDER_DATA_REQUEST,
  SAVE_ORDER_DATA_SUCCESS,
  SAVE_ORDER_DATA_ERROR,
  PAYMENT_CLICKED,
  CHECKOUT_ERROR,
  PAYMENT_REQUEST,
  PAYMENT_SUCCESS,
  PAYMENT_ERROR,
  ADD_DISCOUNT_REQUEST,
  ADD_DISCOUNT_SUCCESS,
  ADD_DISCOUNT_ERROR,
  REMOVE_DISCOUNT_REQUEST,
  REMOVE_DISCOUNT_SUCCESS,
  REMOVE_DISCOUNT_ERROR,
  ADD_GIFT_CARD_ERROR,
  ADD_GIFT_CARD_REQUEST,
  ADD_GIFT_CARD_SUCCESS,
  REMOVE_GIFT_CARD_ERROR,
  REMOVE_GIFT_CARD_REQUEST,
  REMOVE_GIFT_CARD_SUCCESS,
  COMPLETE_GIFT_CARD_ORDER_ERROR,
  COMPLETE_GIFT_CARD_ORDER_REQUEST,
  COMPLETE_GIFT_CARD_ORDER_SUCCESS,
  ATTENDEE_ACTIONED_REFUND_ERROR,
  ATTENDEE_ACTIONED_REFUND_REQUEST,
  ATTENDEE_ACTIONED_REFUND_SUCCESS,
  TIME_EXPIRED,
  CHANGE_PAYMENT_METHOD,
  CREDIT_AND_DEBIT,
  GET_DUMMY_ORDER_LOADING,
  GET_DUMMY_ORDER_SUCCESS,
  ADD_TO_CALENDAR_REQUEST,
  ADD_TO_CALENDAR_SUCCESS,
  ADD_TO_CALENDAR_ERROR,
  TIP_CHANGE
} from "../actions/orderActions";

import { ZIP_CHECKOUT_ERROR } from "../actions/zipMoneyActions";

import { ADD_TICKET_QUANTITY, SELECT_DATE } from "../actions/ticketsActions";

const initialState = {
  data: null,
  providedOrderData: null,
  paymentMethod: CREDIT_AND_DEBIT,
  timeExpired: false,
  tipFees: false,
  orderGet: {
    loading: false,
    error: false
  },
  orderRequest: {
    loading: false,
    error: false
  },
  detailsRequest: {
    loading: false,
    error: false,
    additionalQuestionQuantityError: false,
    saved: false
  },
  waitingToPay: false,
  paymentRequest: {
    loading: false,
    error: false
  },
  authRequest: {
    loading: false,
    error: false
  },
  addDiscountRequest: {
    loading: false,
    error: false
  },
  removeDiscountRequest: {
    loading: false,
    error: false
  },
  giftCardsRequest: {
    loading: false,
    error: false,
    isFullPayment: false
  },
  refundRequest: {
    loading: false,
    error: false,
    success: false
  },
  addToCalendar: {
    loading: false,
    error: false,
    success: false,
    results: []
  }
};

function convertOrder(order) {
  const tickets = !order.tickets
    ? []
    : order.tickets.sort((a, b) => {
        const textA = a.ticketTypeName.toUpperCase();
        const textB = b.ticketTypeName.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
  return {
    ...order,
    tickets
  };
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_ORDER:
      return initialState;
    case CHANGE_PAYMENT_METHOD: {
      return {
        ...state,
        paymentMethod: action.method
      };
    }
    case TIP_CHANGE: {
      return {
        ...state,
        tipFees: action.tipFees
      };
    }
    case ADD_TICKET_QUANTITY: {
      const _id = state.data && state.data._id ? state.data._id : null;
      return {
        ...state,
        data: {
          _id
        },
        orderRequest: {
          loading: false,
          error: false
        }
      };
    }
    case SELECT_DATE:
      return {
        ...state,
        orderRequest: {
          loading: false,
          error: false
        }
      };
    case GET_ORDER_REQUEST:
      return {
        ...state,
        orderGet: {
          loading: true,
          error: false
        }
      };
    case GET_ORDER_SUCCESS:
      return {
        ...state,
        timeExpired: false,
        data: convertOrder(action.order),
        orderGet: {
          loading: false,
          error: false
        }
      };
    case GET_ORDER_ERROR:
      return {
        ...state,
        data: false,
        orderGet: {
          loading: false,
          error: action.error
        }
      };

    case ADD_DISCOUNT_REQUEST:
      return {
        ...state,
        addDiscountRequest: {
          loading: true,
          error: false
        }
      };
    case ADD_DISCOUNT_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.order),
        addDiscountRequest: {
          loading: false,
          error: false
        }
      };
    case ADD_DISCOUNT_ERROR:
      return {
        ...state,
        addDiscountRequest: {
          loading: false,
          error: action.error
        }
      };
    case REMOVE_DISCOUNT_REQUEST:
      return {
        ...state,
        removeDiscountRequest: {
          loading: true,
          error: false
        }
      };
    case REMOVE_DISCOUNT_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.order),
        removeDiscountRequest: {
          loading: false,
          error: false
        }
      };
    case REMOVE_DISCOUNT_ERROR:
      return {
        ...state,
        removeDiscountRequest: {
          loading: false,
          error: action.error
        }
      };

    case ADD_GIFT_CARD_REQUEST:
      return {
        ...state,
        giftCardsRequest: {
          ...state.giftCardsRequest,
          loading: true,
          error: false
        }
      };
    case ADD_GIFT_CARD_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.order),
        giftCardsRequest: {
          ...state.giftCardsRequest,
          loading: false,
          error: false,
          isFullPayment: action.isFullPayment
        }
      };
    case ADD_GIFT_CARD_ERROR:
      return {
        ...state,
        giftCardsRequest: {
          ...state.giftCardsRequest,
          loading: false,
          error: action.error
        }
      };
    case REMOVE_GIFT_CARD_REQUEST:
      return {
        ...state,
        giftCardsRequest: {
          ...state.giftCardsRequest,
          loading: true,
          error: false
        }
      };
    case REMOVE_GIFT_CARD_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.order),
        giftCardsRequest: {
          loading: false,
          error: false,
          isFullPayment: false
        }
      };
    case REMOVE_GIFT_CARD_ERROR:
      return {
        ...state,
        giftCardsRequest: {
          ...state.giftCardsRequest,
          loading: false,
          error: action.error
        }
      };
    case COMPLETE_GIFT_CARD_ORDER_REQUEST:
      return {
        ...state,
        giftCardsRequest: {
          ...state.giftCardsRequest,
          loading: true,
          error: false
        }
      };
    case COMPLETE_GIFT_CARD_ORDER_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.order),
        giftCardsRequest: {
          ...state.giftCardsRequest,
          loading: false,
          error: false
        }
      };
    case COMPLETE_GIFT_CARD_ORDER_ERROR:
      return {
        ...state,
        giftCardsRequest: {
          ...state.giftCardsRequest,
          loading: false,
          error: action.error
        }
      };
    case GET_ORDER_REQ_REQUEST:
      return {
        ...state,
        data: null,
        orderRequest: {
          loading: true,
          error: false
        }
      };
    case GET_ORDER_REQ_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.order),
        timeExpired: false,
        orderRequest: {
          loading: false,
          error: false
        },
        paymentRequest: {
          loading: false,
          error: false
        }
      };
    case GET_DUMMY_ORDER_LOADING:
      return {
        ...state,
        data: null,
        orderRequest: {
          loading: true,
          error: false
        }
      };
    case GET_DUMMY_ORDER_SUCCESS:
      return {
        ...state,
        ...action.order
      };
    case GET_ORDER_REQ_ERROR:
      return {
        ...state,
        data: null,
        orderRequest: {
          loading: false,
          error: action.error
        }
      };
    case SAVE_ORDER_DATA_REQUEST:
      return {
        ...state,
        detailsRequest: {
          loading: true,
          error: false,
          saved: false,
          additionalQuestionQuantityError: false
        }
      };
    case SAVE_ORDER_DATA_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.order),
        detailsRequest: {
          loading: false,
          error: false,
          saved: true,
          additionalQuestionQuantityError: false
        },
        paymentRequest: {
          loading: false,
          error: false
        },
        waitingToPay: false
      };
    case SAVE_ORDER_DATA_ERROR:
      return {
        ...state,
        detailsRequest: {
          loading: false,
          error: action.error,
          saved: false,
          additionalQuestionQuantityError:
            action.additionalQuestionQuantityError
        }
      };

    case PAYMENT_CLICKED:
      return {
        ...state,
        waitingToPay: true
      };
    case CHECKOUT_ERROR:
    case ZIP_CHECKOUT_ERROR: {
      const update = {
        ...state,
        waitingToPay: false
      };
      if (action.error) {
        update.paymentRequest = {
          loading: false,
          error: action.error
        };
      }

      return update;
    }
    case PAYMENT_REQUEST:
      return {
        ...state,
        waitingToPay: false,
        paymentRequest: {
          loading: true,
          error: false
        }
      };
    case PAYMENT_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.order),
        waitingToPay: false,
        paymentRequest: {
          loading: false,
          error: false
        }
      };
    case PAYMENT_ERROR:
      return {
        ...state,
        data: action.order ? convertOrder(action.order) : state.data,
        waitingToPay: false,
        paymentRequest: {
          loading: false,
          error: action.error
        }
      };

    case TIME_EXPIRED:
      return {
        ...state,
        timeExpired: true
      };

    case ATTENDEE_ACTIONED_REFUND_REQUEST:
      return {
        ...state,
        refundRequest: {
          loading: true,
          error: false,
          success: false
        }
      };
    case ATTENDEE_ACTIONED_REFUND_SUCCESS:
      return {
        ...state,
        data: convertOrder(action.result),
        refundRequest: {
          loading: false,
          error: false,
          success: true
        }
      };
    case ATTENDEE_ACTIONED_REFUND_ERROR:
      return {
        ...state,
        refundRequest: {
          loading: false,
          error: true,
          success: false
        }
      };

    case ADD_TO_CALENDAR_REQUEST:
      return {
        ...state,
        addToCalendar: {
          loading: true,
          error: false,
          success: false,
          result: []
        }
      };
    case ADD_TO_CALENDAR_SUCCESS:
      return {
        ...state,
        addToCalendar: {
          loading: false,
          error: false,
          success: true,
          result: action.result
        }
      };
    case ADD_TO_CALENDAR_ERROR:
      return {
        ...state,
        addToCalendar: {
          loading: false,
          error: true,
          success: false,
          result: []
        }
      };
    default:
      return state;
  }
};

export default {
  initialState,
  reducer
};
